import { ref } from "vue";

// Создаем переменную ВНЕ функции, чтобы она была глобальной (одной на всё приложение)
// При первом запуске она проверяет, есть ли токен в браузере
const isAuthenticated = ref(!!localStorage.getItem("token"));

export function useAuth() {
  // Функция для входа: сохраняет токен и меняет статус
  const login = (token) => {
    localStorage.setItem("token", token);
    isAuthenticated.value = true;
  };

  // Функция для выхода: удаляет токен и меняет статус
  const logout = () => {
    localStorage.removeItem("token");
    isAuthenticated.value = false;
  };

  return {
    isAuthenticated,
    login,
    logout,
  };
}
